export default function jobUrlBuilder(jobData, baseUrl) {
  return `${baseUrl}${jobData.BlueXSanitized.Title}_${jobData.BlueXSanitized.City}_${jobData.BlueXJobData.JobId}/`;
}
